<template>
  <div id="contact">
    <div id="contact-card" class="absolute z4 xs-hide sm-hide">
      <div id="contact-card-content" class="center p3" v-on:mouseover="bounceInstance.stop()" v-on:mouseleave="bounceInstance.start()">
        <div class="caps mx-auto">
          бар Лайка<br/>
          224 Greene Avenue<br/>
          Brooklyn, New York<br/>
          11238
        </div>
        <div class="flex pt3 mx-auto center">
        <!-- <div class="pt3 mx-auto center"> -->
          <div class="pr2 center flex-auto"><a href="mailto:laika@e-flux.com" target="_blank">laika@e-flux.com</a></div>
          <!-- <a href="mailto:laika@e-flux.com" target="_blank">laika@e-flux.com</a> -->
          <div class="pl2 center flex-auto">347-529-4321</div>
        </div>
      </div>
    </div>

    <div class="flex items-center md-hide lg-hide full center">
      <div class="caps col-12">
        бар Лайка<br/>
        224 Greene Avenue<br/>
        Brooklyn, New York<br/>
        11238<br/>
        <br/>
        347-529-4321<br/>
        <a href="mailto:laika@e-flux.com" target="_blank">laika@e-flux.com</a>
      </div>
    </div>

    <div id="contact-bottom" class="flex justify-between pb2 md-pb3 px2 md-px4">
      <div id="bottom-left" class="flex-grow"><router-link to="/newsletter">Newsletter</router-link>&nbsp;&nbsp;&nbsp;<!-- <a href="https://www.facebook.com/efluxeflux/
" target="_blank">Facebook</a>&nbsp;&nbsp;&nbsp; --><a href="https://www.instagram.com/efluxbarlaika/" target="_blank">Instagram</a></div>
      <div id="bottom-right" class="flex-grow"><a href="http://www.e-flux.com/" target="_blank">e-flux.com</a></div>
    </div>
  </div>
</template>

<script>
import Bounce from '../bounce'

export default {
  name: 'Contact',
  props: ['sitePosition'],
  data () {
    return {
      bounceInstance: ''
    }
  },
  watch: {
    sitePosition () {
      if (this.sitePosition === 'contact') {
        this.bounceInstance.start()
      } else {
        this.bounceInstance.stop()
      }
    }
  },
  mounted () {
    this.bounceInstance = Bounce({
      el: 'contact-card-content',
      offsetRight: 18,
      offsetBottom: 16
    })
  }
}
</script>

<style lang="css">
  #contact {
    position: relative;
    height: 100vh;
    width: 100%;
    background: var(--color-yellow);
    color: var(--color-red);

    a {
      color: var(--color-red);
    }

    #contact-card {
      width: auto;
      top: 0;
      left: 0;
      opacity: 0;
      pointer-events: none;

      &.show {
        opacity: 1;
        pointer-events: all;
      }
    }

    #contact-card-content {
      width: 33vw;
      margin: 0 auto;
      font-size: 2vw;
      line-height: 1.2;
      background: var(--color-yellow);
      border: 6px solid var(--color-red);
      box-shadow: 12px 10px 0px 0px var(--color-yellow), 12px 10px 0px 6px var(--color-red);
    }

    #contact-bottom {
      position: fixed;
      bottom: 0;
      left: 0;
      right: 0;
      display: none;

      &.show {
        display: flex;
      }
    }
  }
</style>
